import { LOAD_NETWORK_IMAGE_DATA } from '../actions';

export default function networkImageData(state = {}, action) {
    switch (action.type) {
        case LOAD_NETWORK_IMAGE_DATA:
            return {
                ...state,
                payload: action.payload
            };
        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/common/NetworkLogo/reducers/index.js